export const DoppeActionTypeServiceViewerLang = {
    defaultTexts: {
        serviceTitle: 'Service Name',
        description: 'Describe the service you want to promote',
        serviceButtonText: 'Book Now',
        price: '$10'
    }
}